module.exports = __webpack_public_path__ + "img/7_44.f9e176b3.png";